import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiHost } from '../../../../app/infrastructure/http/apiClient';
import type { Category } from '../../application/types';

function authorizationHeader(token?: string | null): string | undefined {
  if (!token) return undefined;
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
}

function apiBaseUrl(): string {
  const host = getApiHost();
  return host.endsWith('/') ? host : `${host}/`;
}

function unwrapCategories(response: unknown): Category[] {
  if (Array.isArray(response)) return response as Category[];
  if (!response || typeof response !== 'object') return [];
  const envelope = response as { data?: unknown };
  if (Array.isArray(envelope.data)) return envelope.data as Category[];
  return [];
}

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseUrl(),
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      const token = (
        getState() as { authorization?: { accessToken?: string | null } }
      ).authorization?.accessToken;
      const value = authorizationHeader(token);
      if (value) headers.set('Authorization', value);
      return headers;
    },
  }),
  tagTypes: ['Category'],
  endpoints: (build) => ({
    getActiveCategories: build.query<Category[], void>({
      query: () => ({
        url: 'categories/active',
        method: 'GET',
      }),
      transformResponse: unwrapCategories,
      providesTags: ['Category'],
    }),
  }),
});

export const { useGetActiveCategoriesQuery } = categoryApi;
